import { Injectable, Signal, WritableSignal, signal, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ActivatedRouteSnapshot, Event, NavigationEnd, Params, Router } from '@angular/router';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { EventRoutePayload } from '../../models';
import { tap, filter } from 'rxjs';
import { omit } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class IqRoutesRegisterService {
    private readonly _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private readonly _router: Router = inject(Router);
    private readonly _eventBroker: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    private _destroyRef: DestroyRef = inject(DestroyRef);

    private _paramsSignal: Signal<Params> = toSignal(this._activatedRoute.params);
    loaded: WritableSignal<boolean> = signal(false);

    constructor() {
        this.initialize();
    }

    private initialize() {
        this._router.events.pipe(
            takeUntilDestroyed(this._destroyRef),
            filter((event: Event) => event instanceof NavigationEnd),
            tap(() => this.dispatchRouteChange())
        ).subscribe();

        this.loaded.set(true);
        this.dispatchRouteChange();
    }

    private dispatchRouteChange() {
        let activeRoute: ActivatedRoute = this._activatedRoute;
        while (activeRoute.firstChild) {
            activeRoute = activeRoute.firstChild;
        }
        const route = activeRoute.snapshot;
        const iqWorkflowRoute: EventRoutePayload = {
            path: route.url.join('/'),
            params: route.params,
            pageTitle: route.title,
            analyticsPageName: route.data.analyticsPageName,
            locked: false,
            data: omit(route.data, ['dashboard']),
        };

        this._eventBroker.dispatch({
            name: 'type:route:changed',
            payload: iqWorkflowRoute,
        });
    }
}